import { createSlice } from '@reduxjs/toolkit'
import { PrefixType } from '../../interfaces/Prefix'

const selectedJobsSlice = (prefix: PrefixType, initialState = []) =>
    createSlice({
        name: `${prefix}/selectedJobs`,
        initialState,
        reducers: {
            selectAllJobs: (state, action) => action.payload,
            resetSelectedJobs: () => initialState,
        },
    })

const selectedJobs = (prefix: PrefixType, initialState = []) => selectedJobsSlice(prefix, initialState).reducer

export const selectedJobsActions = (prefix: PrefixType) => selectedJobsSlice(prefix).actions

export default selectedJobs
